import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Rajesh Routhu </span>
            from <span className="purple"> Visakhapatanam, India.</span>
            <br />
            I Worked as a Associate IT Consultant at ITC Infotech.
            <br />
            I have completed B.Tech in Computer Science and Engineering at Avanthi Institute of Engineering and Technology.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Video Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Cooking
            </li>
            <li className="about-activity">
              <ImPointRight /> DIY's
            </li>
            <li className="about-activity">
              <ImPointRight /> Gardning
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Learn by doing what u like to do."{" "}
          </p>
          <footer className="blockquote-footer">Rajesh</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
